import VersionedFields, { latestVersions } from "../../../versions/index";

type VersionKeys = keyof typeof VersionedFields;
type LoanType = "bridge" | "dscr";

const getLoanTypeKey = (loanType?: string): LoanType | null => {
    const normalized = loanType?.toLowerCase();
    if (normalized?.includes("bridge")) return "bridge";
    if (normalized?.includes("dscr")) return "dscr";
    return null;
};

const getVersionedFields = (
    loanType: string,
    version?: VersionKeys
) => {
    const loanTypeKey = getLoanTypeKey(loanType);

    if (!loanTypeKey) {
        throw new Error("Invalid loan type");
    }

    // Use provided version OR fallback to latest
    const versionToUse: VersionKeys =
        version ||
        latestVersions[loanTypeKey];

    return VersionedFields[versionToUse];
};

export default getVersionedFields;